import { Button, DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommOrderMessageQuickInfo extends Layout {
    buttonSeeAllMessages: Button;
    labelTitle: Label;
    panelMcMessageList: Panel;
    sourceMobileCommMessage: DataSource;
    tableMcMessage: Table;
}
